// extracted by mini-css-extract-plugin
export var addButton = "_ff-0";
export var border = "_ff-8";
export var check = "_ff-h";
export var danger = "_ff-6";
export var dropdownContainer = "_ff-1";
export var editModalBody = "_ff-j";
export var footerContainer = "_ff-i";
export var fullWidth = "_ff-a";
export var hide = "_ff-9";
export var icon = "_ff-3";
export var input = "_ff-7";
export var inputFlex = "_ff-b";
export var inputWrapper = "_ff-c";
export var manualFocus = "_ff-5";
export var optionButton = "_ff-4";
export var pillWrapper = "_ff-e";
export var pointer = "_ff-2";
export var showOverflow = "_ff-f";
export var tagsFlex = "_ff-d";
export var xButton = "_ff-g";